import { render, staticRenderFns } from "./buyers.vue?vue&type=template&id=50d615f0&scoped=true"
import script from "./buyers.vue?vue&type=script&lang=ts"
export * from "./buyers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d615f0",
  null
  
)

export default component.exports